import { getBirthday } from "@/core/global/http3Shape"
import { getCaseList } from "@/core/global/ThirdDataMgr"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { QUERY_PARAMS_STORAGE_KEY } from "../../../../modules/Patient/PatientList/patientTable/table.config"

import {
  addNewCaseService,
  createPatient,
  fetchPatientByIdService,
  getExistingPatientList,
  getPatientList,
  updatePatient,
  addPatientServiceV2,
  addCaseServiceV2,
} from "./patient.service"
import {
  AddNewPatientParams,
  CreateCaseParams,
  ExistingPatientQueryParams,
  PatientQueryparams,
  updatePatientParams,
} from "./patient.types"
import * as userApiService from "@/core/app/slices/user/user.service"
import { deserializePatientListUser } from "@/core/model/Patient"

export const fetchPatientList = createAsyncThunk(
  "patientService/fetchPatientList",
  async (
    {
      patientQueryparams,
    }: { patientQueryparams: PatientQueryparams; filterType: string },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      localStorage.setItem(
        QUERY_PARAMS_STORAGE_KEY,
        JSON.stringify(patientQueryparams),
      )
      return await getPatientList(orgId, patientQueryparams)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const addNewPatient = createAsyncThunk(
  "patientService/addNewPatient",
  async (
    addNewPatientParams: AddNewPatientParams,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await createPatient(orgId, addNewPatientParams)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const addNewCase = createAsyncThunk(
  "patientService/addNewCaseService",
  async (
    { patientId, payload }: CreateCaseParams,
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await addNewCaseService(orgId, patientId, payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchPatientById = createAsyncThunk(
  "patientService/fetchPatientById",
  async (
    { patientId }: { patientId: string },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await fetchPatientByIdService(orgId, patientId)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchExistingPatientList = createAsyncThunk(
  "patientService/fetchExistingPatientList",
  async (
    {
      existingPatientQueryparams,
    }: { existingPatientQueryparams: ExistingPatientQueryParams },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await getExistingPatientList(orgId, existingPatientQueryparams)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const updatePatientData = createAsyncThunk(
  "patientService/updatePatientData",
  async (
    { patientId, payload }: { patientId: string; payload: updatePatientParams },
    { rejectWithValue, getState },
  ) => {
    const orgId = getState().userService.user.current_orgId
    try {
      return await updatePatient(orgId, patientId, payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

// add patient---version2
export const addPatientV2 = createAsyncThunk(
  "patientService/addPatientV2",
  async (payload: AddNewPatientParams, { rejectWithValue }) => {
    console.log("add patient.......", payload)
    try {
      return await addPatientServiceV2(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
// add case---version2
export const addCaseV2 = createAsyncThunk(
  "patientService/addCaseV2",
  async (payload: AddNewPatientParams, { rejectWithValue }) => {
    try {
      return await addCaseServiceV2(payload)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
// get 3shape case list
export const get3ShapeCaseList = createAsyncThunk(
  "patientService/get3ShapeCaseList",
  async (
    param: { page: number; type: "3Shape" | "Medit" | "Alliedstar"; name: string },
    { rejectWithValue },
  ) => {
    try {
      return await getCaseList(param)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
// get 3shape birthday data
export const getBirthdayfor3Shape = createAsyncThunk(
  "patientService/getBirthdayfor3Shape",
  async (param: { url: string }, { rejectWithValue }) => {
    try {
      console.log("3shapebirth_param_thunk", param)
      return await getBirthday(param.url)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
export const updatePatientRecordsForAssignPopup = createAsyncThunk(
  "patientService/updatePatientRecordsForAssignPopup",
  async (
    payload: {
      patientId
      phase: number
      assignedTo: number
    },
    { rejectWithValue, getState },
  ) => {
    try {
      const userState = getState().userService.user
      const orgId = userState.isAllowToViewAllOrg
        ? userState.authorized_roles[0].org_id
        : userState.current_orgId

      const { patientId, phase, assignedTo } = payload

      const DoctorsList = getState()?.doctorService?.doctorList
      let foundDoctor = {
        ...DoctorsList.find((doctor) => doctor.id === assignedTo),
      }

      const response = await userApiService.getUserPreferences(
        orgId,
        String(assignedTo),
      )
      const { preferences } = response.result
      foundDoctor.preference = JSON.stringify(preferences)

      const doctorObj = deserializePatientListUser({
        assigned_to: assignedTo,
        user: foundDoctor,
      })

      return {
        patientId,
        phase,
        assignedTo,
        user: doctorObj,
      }
    } catch (error) {
      console.error(
        "Error in updating patient record, from assign popup : ",
        error,
      )
      rejectWithValue(error)
    }
  },
)
